import { useEffect, useState } from "react";
import axios from "../utils/axiosInstance";
import LuxuryImage from "../components/LuxuryImage";

function OrdersPage() {

  const [orders, setOrders] = useState([]);

  useEffect(() => {

    fetchOrders();

  }, []);

  const fetchOrders = async () => {

    try {

      const res =
        await axios.get("/api/orders/my-orders");

      setOrders(res.data || []);

    } catch (err) {

      console.error(err);

    }

  };

  return (

    <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">

      {/* HEADER */}

      <div className="mb-10">

        <p className="uppercase tracking-[0.3em] text-xs text-stone-400 mb-3">
          Your Purchase History
        </p>

        <h1 className="text-4xl md:text-5xl font-serif">
          My Orders
        </h1>

      </div>

      {/* EMPTY */}

      {orders.length === 0 ? (

        <div className="bg-white border rounded-3xl p-16 text-center">

          <h2 className="text-3xl font-serif mb-4">
            No Orders Yet
          </h2>

          <p className="text-stone-500">
            Your sacred art journey begins here.
          </p>

        </div>

      ) : (

        <div className="space-y-8">

          {orders.map((order) => (

            <div
              key={order.id}
              className="bg-white border border-stone-200 rounded-3xl overflow-hidden shadow-sm"
            >

              {/* TOP SECTION */}

              <div className="border-b border-stone-100 px-6 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-stone-50">

                <div>

                  <p className="text-sm text-stone-400 uppercase tracking-widest mb-1">
                    Order ID
                  </p>

                  <h2 className="font-semibold text-lg">
                    #{order.id}
                  </h2>

                </div>

                <div>

                  <p className="text-sm text-stone-400 uppercase tracking-widest mb-1">
                    Payment
                  </p>

                  <p className="font-medium">
                    {order.paymentMethod}
                  </p>

                </div>

                <div>

                  <p className="text-sm text-stone-400 uppercase tracking-widest mb-1">
                    Status
                  </p>

                  <span
                    className={`
                      inline-flex items-center
                      px-4 py-1 rounded-full
                      text-sm font-medium

                      ${
                        order.status === "DELIVERED"
                          ? "bg-green-100 text-green-700"

                          : order.status === "CANCELLED"
                          ? "bg-red-100 text-red-700"

                          : order.status === "OUT_FOR_DELIVERY"
                          ? "bg-orange-100 text-orange-700"

                          : order.status === "SHIPPED"
                          ? "bg-purple-100 text-purple-700"

                          : "bg-blue-100 text-blue-700"
                      }
                    `}
                  >
                    {order.status.replaceAll("_", " ")}
                  </span>

                </div>

                <div>

                  <p className="text-sm text-stone-400 uppercase tracking-widest mb-1">
                    Total
                  </p>

                  <p className="font-semibold text-xl">
                    ₹ {order.finalAmount}
                  </p>
                  <p className="text-sm text-stone-500 mt-1">
                    Expected:
                    {" "}
                    {order.expectedDeliveryDate || "-"}
                  </p>

                </div>
                <div>

                  <p className="text-sm text-stone-400 uppercase tracking-widest mb-1">
                    Courier
                  </p>

                  <p className="font-medium">
                    {order.courierPartner || "-"}
                  </p>

                </div>

                <div>

                  <p className="text-sm text-stone-400 uppercase tracking-widest mb-1">
                    Tracking
                  </p>

                  <p className="font-medium">
                    {order.trackingNumber || "-"}
                  </p>

                </div>
                <button
                  onClick={() =>
                    window.open(
                      `/track-order?id=${order.id}`,
                      "_blank"
                    )
                  }
                  className="
                    bg-purple-600
                    text-white
                    px-4 py-2
                    rounded-xl
                    text-sm
                  "
                >
                  Track Order
                </button>

              </div>

              {/* ITEMS */}

              <div className="p-6 space-y-5">

                {order.items?.map((item) => {

                  const image =
                    item.imageUrl ||
                    "/images/placeholder.png";

                  return (

                    <div
                      key={`${order.id}-${item.id}`}
                      className="
                        flex flex-col md:flex-row
                        gap-5
                        border border-stone-100
                        rounded-2xl
                        p-4
                        hover:shadow-lg
                        transition
                      "
                    >

                      {/* IMAGE */}

                      <LuxuryImage
                        src={image}
                        alt={item.productName}
                        className="
                          w-full md:w-36
                          h-36
                          object-cover
                          rounded-2xl
                        "
                        skeletonClass="rounded-2xl"
                      />

                      {/* DETAILS */}

                      <div className="flex-1">

                        <h3 className="text-xl font-medium mb-2">
                          {item.productName}
                        </h3>

                        <div className="space-y-1 text-stone-500 text-sm">

                          <p>
                            Size: {item.size || "Standard"}
                          </p>

                          <p>
                            Quantity: {item.quantity}
                          </p>

                          <p>
                            Price: ₹ {item.price}
                          </p>

                        </div>

                        {/* DELIVERY */}
                        {
                          order.deliveredDate && (

                            <p className="text-green-700 text-sm mb-3">

                              Delivered on:
                              {" "}
                              {order.deliveredDate}

                            </p>

                          )
                        }

                        <div className="mt-4 flex flex-wrap gap-3">

                          <span
                            className="
                              px-4 py-2 rounded-full
                              text-sm
                              bg-blue-50
                              text-blue-700
                            "
                          >
                            {
                              order.status === "PLACED"
                                ? "📝 Order Placed"

                                : order.status === "CONFIRMED"
                                ? "✅ Order Confirmed"

                                : order.status === "PACKED"
                                ? "📦 Order Packed"

                                : order.status === "SHIPPED"
                                ? "🚚 Shipped"

                                : order.status === "OUT_FOR_DELIVERY"
                                ? "🛵 Out For Delivery"

                                : order.status === "DELIVERED"
                                ? "🎉 Delivered"

                                : order.status === "CANCELLED"
                                ? "❌ Cancelled"

                                : order.status
                            }
                          </span>

                          <span className="
                            px-4 py-2 rounded-full
                            bg-green-50
                            text-green-700
                            text-sm
                          ">
                            ✔ Secure Payment
                          </span>

                        </div>

                      </div>

                    </div>

                  );

                })}

              </div>

            </div>

          ))}

        </div>

      )}

    </div>

  );

}

export default OrdersPage;